<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Business Analysis Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="key"
              show-select
              v-bind:search="search"
              v-model="selected"
              @input="enterSelect"
              @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'stmtRef')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'stmtRef')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  props: {
    mainTtyCls: String,
    riType: String
  },
  data() {
    return {
      headers: [
        { text: 'Bus An', value: 'busAn' },
        { text: 'Description', value: 'busAnDesc' }
      ],
      selected: [],
      parameter: [],
      // items: [],
      // paramItems: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
      // checkedItems: [],
      // checkedItemsAll: []
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    menu: function () {
      this.doInit()
    }
  },
  methods: {
    async doInit() {
      this.busAn = this.mainTtyCls.split(',')
      const apiURI = this.menu.commonDataList
      const expand = {
        listName: 'busAnList',
        paramString: this.ritype
      }
      if (apiURI) {
        this.loading = true
        await this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            this.items = []
            this.checkedItems = this.busAn
            if (this.busAn !== this.checkedItems) {
              // CBO: to reset the 'this.checkedItems' if called from different mode
              this.doReset()
              this.checkedItems = this.busAn
            }
            const data = result.data.dataList
            if (data) {
              data.map((busAn) => {
                const convertList = {
                  key: busAn.value,
                  busAn: busAn.value,
                  busAnDesc: busAn.label
                }
                if (this.checkedItems.includes(busAn.value)) {
                  const execICList = {
                    key: busAn.value,
                    busAn: busAn.value,
                    busAnDesc: busAn.label
                  }
                  this.selectedItems.push(execICList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === 'All') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
    // collectItems(event, item) {
    //   if (event) {
    //     if (this.checkedItems.toString() === 'All') {
    //       this.doReset()
    //     }
    //     this.checkedItems.push(item)
    //     this.checkedItems.sort()
    //   } else {
    //     this.checkedItems.splice(this.checkedItems.indexOf(item), 1)
    //     this.checkedItems.sort()
    //   }
    // },
    // doReset() {
    //   this.checkedItems = []
    //   this.selected = []
    //   this.checkedItemsAll = []
    // },
    // doSelect(opt, caller) {
    //   let selectedObj = {}
    //   if (opt === 'All') {
    //     this.doReset()
    //     this.checkedItemsAll.push('All')
    //     selectedObj = {
    //       finalSelectedItems: this.checkedItemsAll
    //     }
    //   } else {
    //     if (this.checkedItems.length === 0 && this.isDefAll === true) {
    //       selectedObj = {
    //         finalSelectedItems: ['All']
    //       }
    //     } else {
    //       selectedObj = {
    //         finalSelectedItems: this.checkedItems
    //       }
    //     }
    //   }
    //   this.$emit('doAssign', selectedObj)
    //   this.$emit('close', caller)
    // }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ]
}
</script>
